"use client";

import { useNavigate } from "react-router-dom";
import LiveTrackingCards from "./LiveTrackingCards";
import BusTabsNav from "./BusTabsNav";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Merge } from "lucide-react";

const LiveTrackingPage = () => {
  const navigate = useNavigate();

  const handleSelectBus = (vehicleId, shiftId) => {
    const params = new URLSearchParams({ vehicleId, shiftId: shiftId || "" });
    navigate(`/dashboard/live-tracking/map?${params.toString()}`);
  };

  const handleCombineBuses = () => {
    navigate("/dashboard/live-tracking/merge-session");
  };

  return (
    <div className="space-y-6">
      <BusTabsNav currentTab="tracking" />
      <Card className="border-0 shadow-sm">
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-6">
            <div>
              <h2 className="text-xl font-semibold text-gray-800 mb-1">Live Tracking</h2>
              <p className="text-sm text-gray-500">Select a bus to track on the map</p>
            </div>
            <Button
              onClick={handleCombineBuses}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              <Merge className="h-4 w-4 mr-2" />
              Combine Buses
            </Button>
          </div>
          <LiveTrackingCards onSelectBus={handleSelectBus} />
        </CardContent>
      </Card>
    </div>
  );
};

export default LiveTrackingPage;
